import ProductHighlight from './components/ProductHighlight';
export default ProductHighlight;